import React from 'react';
import ManageUser from './ManageUser';
import http from 'utils/http';
import events from 'utils/evemts';
import { connect } from 'react-redux';
import { setDocAction } from 'store/actions/docAction';
import moment from 'moment/moment';
import cookies from 'utils/cookies';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
class ManageUserContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlineList: [],
      userList: [],
      otherUserList: [],
      filteredData: [],
      filter: {
        type: 'ALL',
        expiry: false,
        day: 1,
      },
      modal: false,
      action: false,
      tryUserFields: {},
      userFields: {},
      userErrors: {},
      location: false,
      locationType: false,
      anchorEl: null,
      station: [],
      training: false,
      doc: {},
      passwordVal: '',
      successModal: false,
      filterValue:{},
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchAirlines();
    this.fetchUsers();
    this.eventSource = events('admin', 'user');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      let station = parseInt(cookies.get('station'));
      if (msg.action == 'add' && msg.data?.stations?.some(stn => stn.id === station)) {
        this.setState({ userList: [...this.state.userList, msg.data] }, () => {
          this.filterData();
        });
      }
      if (msg.action == 'update') {
        const userList = [...this.state.userList];
        const index = userList.findIndex(c => msg.data && c.id == msg.data.id);
        if (index > -1) {
          userList[index] = {
            ...msg.data,
            stations: msg.data?.stations && msg.data?.stations?.length > 0 ? msg.data.stations : userList[index].stations,
            docs: userList[index].docs
          };
          if (!userList[index].stations?.some(stn => stn.id === station) && msg?.data?.master) {
            userList.splice(index, 1);
          }
          this.setState({ userList }, () => {
            this.filterData();
          });
        } else {
          if (msg.data?.stations && msg.data?.stations?.length > 0) {
            if (msg.data?.stations?.some(stn => stn.id === station)) {
              this.fetchUsers();
            }
          }else if(!msg.data?.master){
            this.fetchUsers();
          }
        }
      }
      if (msg.action == 'doc_add' || msg.action == 'doc_update' || msg.action == 'doc_delete') {
        const userList = [...this.state.userList];
        const index = userList.findIndex(c => msg.data && c.id == msg.data.userId);
        if (msg.action == 'doc_add' && index > -1) {
          userList[index] = {
            ...userList[index],
            docs: [...userList[index].docs, msg.data]
          };
          this.setState({ userList }, () => {
            this.filterData();
          });
        }
        if ((msg.action == 'doc_update' || msg.action == 'doc_delete') && index > -1) {
          let docs = [...userList[index].docs];
          const i = docs.findIndex(c => c.id == msg.data.id);
          if (msg.action == 'doc_update') {
            if (i > -1) {
              docs[i] = {
                ...msg.data,
                added_by: docs[i].added_by
              };
              userList[index].docs = docs;
              this.setState({ userList });
            } else {
              docs.push({
                ...msg.data,
                added_by: {}
              });
              userList[index].docs = docs;
              this.setState({ userList }, () => {
                this.filterData();
              });
            }
          }
          if (msg.action == 'doc_delete') {
            if (i > -1) {
              docs.splice(i, 1);
              userList[index].docs = docs;
              this.setState({ userList }, () => {
                this.filterData();
              });
            }
          }
        }

        if (this.props.doc.modal == 'user' && this.props.doc.id == msg.data.userId && index > -1) {
          this.props.setDoc({
            modal: 'user',
            id: userList[index].id,
            name: userList[index].name,
            data: userList[index].docs
          });
        }
      }
    };
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        this.setState({ airlineList: response.data.data });
      });
  };

  fetchUsers = () => {
    http.get('/user')
      .then((response) => {
        // handle success
        this.setState({ userList: response.data.data }, () => {
          this.filterData();
        });
      });
  };

  fetchOtherUsers = () => {
    const { tryUserFields } = this.state;
    const { first_name, last_name } = tryUserFields;

    const params = new URLSearchParams();
    if (first_name) params.append('first_name', first_name);
    if (last_name) params.append('last_name', last_name);

    const query = params.toString();
    http.get(`/user/trypod?${query}`)
      .then((response) => {
        // handle success
        this.setState({ otherUserList: response.data.data });
      });
  };

  // filter
  filterData = () => {
    let filteredData = [...this.state.userList];
    if (this.state.filter.type === 'ACTIVE') {
      filteredData = filteredData.filter((item) => (
        item.active === true && item.login === true
      ));
    }
    if (this.state.filter.type === 'INACTIVE') {
      filteredData = filteredData.filter((item) => item.login === false);
    }
    if (this.state.filter.type === 'DEACTIVATED') {
      filteredData = filteredData.filter((item) => item.active === false);
    }

    if (this.state.filter.expiry) {
      filteredData = filteredData.filter((item) => {
        if (item.docs && item.docs.length > 0) {
          let expiry = false;
          for (let doc of item.docs) {
            let diff = moment(doc.data.expiry_date).diff(moment.utc(), 'days');
            if (diff >= 0 && diff <= this.state.filter.day) {
              expiry = true;
            }
          }
          return expiry;
        } else {
          return false;
        }
      });
    }

    if (this.state.filterValue && this.state.filterValue.search) {
      const search = this.state.filterValue.search.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return (
          item.first_name?.toLowerCase().includes(search) ||
          item.last_name?.toLowerCase().includes(search) ||
          item.username?.toLowerCase().includes(search) ||
          item.email?.toLowerCase().includes(search)
        );
      });
    }
    this.setState({ filteredData: filteredData });
  };

  handleExport = () => {
    const filterType = this.state.filter.type || 'ALL';
    const filterLabels = {
      ALL: 'All Users',
      ACTIVE: 'Active Users',
      INACTIVE: 'Inactive Users',
      DEACTIVATED: 'Deactivated Users'
    };
    const filterLabel = filterLabels[filterType] || filterType;
    const stationCode = cookies.get('station_code') || '';

    const headerRow = [
      'First Name',
      'Last Name',
      'User Name',
      'Email',
      'Mobile',
      'Role',
      'Department',
      'Stations',
      'ShopTalk User',
      'Account Status',
      'Deactivated Reason'
    ];

    const metadataRows = [
      ['Tristar CABA'],
      [`Station: ${stationCode}, Filter: ${filterLabel}`],
      []
    ];

    const dataRows = (this.state.filteredData || []).map(user => [
      user.first_name || '',
      user.last_name || '',
      user.username || '',
      user.email || '',
      user.mobile && String(user.mobile).length >= 5 ? user.mobile : '',
      user.role || '',
      user.contract_types ? user.contract_types.join(', ') : '',
      user.stations ? user.stations.map(st => st.code).join(', ') : '',
      user.shoptalk_access ? 'Yes' : 'No',
      !user.active ? 'Deactivated' : (!user.login ? 'Inactive' : 'Active'),
      user.reason || ''
    ]);

    const aoa = [
      ...metadataRows,
      headerRow,
      ...dataRows
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // Merge metadata rows
    ws['!merges'] = [
      {
        s: {
          r: 0,
          c: 0
        },
        e: {
          r: 0,
          c: 10
        }
      },
      {
        s: {
          r: 1,
          c: 0
        },
        e: {
          r: 1,
          c: 10
        }
      }
    ];

    // Style metadata and headers
    ws['A1'].s = {
      font: {
        bold: true,
        color: { rgb: '333333' } 
      },
      alignment: {
        horizontal: 'center',
        vertical: 'center' 
      }
    };
    ws['A2'].s = {
      font: { bold: true, },
      alignment: {
        horizontal: 'center',
        vertical: 'center' 
      }
    };

    const colsCount = headerRow.length;
    for (let c = 0; c < colsCount; c++) {
      const cellRef = XLSX.utils.encode_cell({
        r: 3,
        c: c 
      });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true },
          alignment: {
            horizontal: 'center',
            vertical: 'center' 
          }
        };
      }
    }

    // Dynamic column widths
    const maxColWidths = [];
    aoa.forEach((row) => {
      row.forEach((val, colIdx) => {
        const len = val ? String(val).length : 0;
        if (!maxColWidths[colIdx] || len > maxColWidths[colIdx]) {
          maxColWidths[colIdx] = len;
        }
      });
    });
    ws['!cols'] = maxColWidths.map(w => ({ wch: Math.max(w + 3, 11) }));

    // Row heights
    ws['!rows'] = [];
    ws['!rows'][0] = { hpt: 30 };
    ws['!rows'][1] = { hpt: 20 };
    ws['!rows'][3] = { hpt: 25 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');

    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const filename = `CABA User list ${stationCode}.xlsx`;
    saveAs(blob, filename);
  };


  onChangeFilter = (e) => {
    let filter = { ...this.state.filter };
    filter[e.target.name] = e.target.type == 'checkbox' ? e.target.checked : e.target.value;
    this.setState({ filter }, () => {
      this.filterData();
    });
  };


  handleLocation = (locationType, v, data = {}, anchorEl = null) => {
    this.setState({
      location: v,
      locationType,
      station: data,
      anchorEl
    });
  };

  handleDoc = (row) => {
    this.props.setDoc({
      modal: 'user',
      id: row.id,
      name: row.name,
      data: row.docs
    });
  };

  handleOpen = (modal, action, data = {}) => {
    let airlineList = [];
    let contract_types = [];
    let station_code = cookies.get('station_code');
    let country_code = '';
    let phone_number = '';
    let shoptalk_access = data.shoptalk_access || false;
    if (modal==='user' && action === 'add') {
      country_code = '+1';
    }
    if (data.airlines) {
      airlineList = data.airlines[station_code] || [];
    }
    if (data.contract_types) {
      contract_types = data.contract_types || [];
    }
    if (data.mobile) {
      let mobile = `+${data.mobile}`;
      const match = mobile.match(/^(\+\d{1,4})(\d{10})$/);
      if (match) {
        country_code = match[1];
        phone_number = match[2];
      }
    }
    this.setState({
      modal,
      action,
      userFields: {
        ...data,
        password: null,
        airlines: airlineList,
        contract_types: contract_types,
        country_code,
        mobile: phone_number,
        shoptalk_access: shoptalk_access,
        stations: data.stations || []
      }
    });
  };

  onClose = () => {
    this.setState({
      modal: false,
      successModal: false,
      action: false,
      userFields: {},
      userErrors: {},
      tryUserFields: {},
      otherUserList: []
    }, () => {
      this.filterData();
    });
  };

  checkPassword = () => {
    let valid = false;
    let fields = {
      passcheck1: true,
      passcheck2: true
    };
    let passwordInputValue = this.state.userFields.password;
    if (passwordInputValue) {
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const passwordLength = passwordInputValue.length;
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
      const digitsPassword = digitsRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword = minLengthRegExp.test(passwordInputValue);
      let errMsg = '';
      if (passwordLength === 0) {
        fields.passcheck2 = false;
        fields.passcheck1 = false;
        errMsg = 'Password is empty! Password must contain minumum 8 characters with at least one Uppercase, one Lowercase, one digit, one Special Characters  ';
      } else if (!uppercasePassword) {
        fields.passcheck2 = false;
        errMsg = 'At least one Uppercase';
      } else if (!lowercasePassword) {
        fields.passcheck2 = false;
        errMsg = 'At least one Lowercase';
      } else if (!digitsPassword) {
        fields.passcheck2 = false;
        errMsg = 'At least one digit';
      } else if (!specialCharPassword) {
        fields.passcheck2 = false;
        errMsg = 'At least one Special Characters';
      }
      if (!minLengthPassword) {
        fields.passcheck1 = false;
        errMsg = 'At least minumum 8 characters';
      }
      if (errMsg == '') {
        valid = true;
      }
      this.setState({
        userFields: {
          ...this.state.userFields,
          ...fields
        },
        userErrors: { password: errMsg }
      });
    } else {
      this.setState({
        userFields: {
          ...this.state.userFields,
          passcheck1: false,
          passcheck2: false
        },
        userErrors: {}
      });
    }
    return valid;
  };

  onChange = (e) => {
    let value;
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    this.setState({
      userFields: {
        ...this.state.userFields,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.name == 'password') {
        this.checkPassword();
      }
    });
  };

  onChangeTry = (e) => {
    this.setState({
      tryUserFields: {
        ...this.state.tryUserFields,
        [e.target.name]: e.target.value
      }
    });
  };

  validation = () => {
    const userFields = { ...this.state.userFields };
    const error = {};
    let formValid = true;
    if (!userFields.first_name || (userFields.first_name.trim().length === 0)) {
      formValid = false;
      error.first_name = true;
    }
    if (!userFields.last_name || (userFields.last_name.trim().length === 0)) {
      formValid = false;
      error.last_name = true;
    }
    if (!userFields.username || (userFields.username.trim().length === 0)) {
      formValid = false;
      error.username = true;
    }
    if (['Supervisor', 'Manager', 'System Admin'].includes(userFields.role) && (!userFields.email || (userFields.email.trim().length === 0))) {
      formValid = false;
      error.email = true;
    }
    if (userFields.role && userFields.role === 'System Admin' && (!userFields.mobile || (userFields.mobile.trim().length === 0))) {
      formValid = false;
      error.mobile = true;
    }
    if (userFields.username && /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(userFields.username) && !userFields.app) {
      formValid = false;
      error.username = true;
      error.username_msg = 'Enter valid username';
    }
    if (userFields.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(userFields.email)) {
      formValid = false;
      error.email = true;
      error.email_msg = 'Enter valid email';
    }
    // check if 10 digit mobile number or country code and 10 digit number 
    if (userFields.mobile && !/^(\+\d{1,3})?\d{10}$/.test(userFields.mobile)) {
      formValid = false;
      error.mobile = true;
      error.mobile_msg = 'Enter valid mobile number';
    }
    if (!userFields.role || (userFields.role.length === 0)) {
      formValid = false;
      error.role = true;
    }
    if (!userFields.contract_types || (userFields.contract_types.length === 0)) {
      formValid = false;
      error.contract_types = true;
    }
    // if (this.state.action === 'add') {
    //   if (!userFields.password || (userFields.password.length === 0)) {
    //     formValid = false;
    //     error.password = 'Please enter the password';
    //   }
    // }
    this.setState({ userErrors: error });
    return formValid;
  };

  validationDeactivate = () => {
    const userFields = { ...this.state.userFields };
    const error = {};
    let formValid = true;
    if (!userFields.reason || (userFields.reason.trim().length === 0)) {
      formValid = false;
      error.reason = true;
    }
    this.setState({ userErrors: error });
    return formValid;
  };

  addUser = async (e) => {
    e.preventDefault();
    let formdata = { ...this.state.userFields };
    let country_code = formdata.country_code ? formdata.country_code.split('+').join('') : '';
    if (formdata.mobile && formdata.mobile.trim() !== '') {
      formdata.mobile = country_code + formdata.mobile;
    } else {
      formdata.mobile = '';
    }
    if (this.validation()) {
      //if userFields.email === "" set it to null
      if (formdata.email === '') {
        formdata.email = null;
      }
      http.post('/user', formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            userFields: {},
            userErrors: {},
            action: null,
          });
        }
      });
    }
  };

  editUser = async (e) => {
    e.preventDefault();
    if (this.validation()) {
      let country_code = this.state.userFields?.country_code ? this.state.userFields.country_code.split('+').join('') : '';
      let mobileValue = '';
      if (this.state.userFields.mobile && this.state.userFields.mobile.trim() !== '') {
        mobileValue = country_code + this.state.userFields.mobile;
      }
      let formdata = {
        app: this.state.userFields.app,
        appId: this.state.userFields.appId,
        first_name: this.state.userFields.first_name,
        last_name: this.state.userFields.last_name,
        username: this.state.userFields.username,
        mobile: mobileValue,
        role: this.state.userFields.role,
        airlines: this.state.userFields.airlines || null,
        contract_types: this.state.userFields.contract_types || null,
        shoptalk_access: this.state.userFields.shoptalk_access || false,
        stations: this.state.userFields.stations || []
      };
      if (this.state.userFields.email !== '' && this.state.userFields.email !== null) {
        formdata.email = this.state.userFields.email;
      }
      http.put('/user/' + this.state.userFields.id, formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            userFields: {},
            userErrors: {},
            action: null,
          });
        }
      });
    }
  };

  handleChangePassword = () => {
    if (this.checkPassword()) {
      let formdata = { password: this.state.userFields.password };
      http.put('/user/' + this.state.userFields.id, formdata).then(({ data }) => {
        if (data.status == 'success') {
          localStorage.setItem('user_details', JSON.stringify(this.state.userFields));
          this.setState({
            modal: false,
            successModal: true,
            userFields: {},
            userErrors: {},
            action: null,
          });
          window.open('/print_user_details', '_blank');
        }
      });
    }
  };

  active = async (e) => {
    e.preventDefault();
    let formdata = { active: true };
    http.put('/user/' + this.state.userFields.id, formdata).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          modal: false,
          userFields: {},
          userErrors: {},
          action: null,
        });
      }
    });
  };

  deactive = async (e) => {
    e.preventDefault();
    let formdata = {
      active: false,
      reason: this.state.userFields.reason
    };
    if (this.validationDeactivate()) {
      http.put('/user/' + this.state.userFields.id, formdata).then(({ data }) => {
        if (data.status == 'success') {
          this.setState({
            modal: false,
            userFields: {},
            userErrors: {},
            action: null,
          });
        }
      });
    }
  };

  handleTraining = (training, doc = {}, anchorEl = null) => {
    this.setState({
      training,
      doc,
      anchorEl
    });
  };

  handleRetraining = () => {
    // e.preventDefault();
    // if (this.validateUser()) {
    let formdata = { expiry_date: this.state.userFields.expiry_date };
    let id = this.state.doc.id;
    http.put('/document/user/' + id, formdata).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({
          training: false,
          modal: false,
          userFields: {},
          userErrors: {},
          action: null,
        });
        // toast.success(data.message);
      }
    });
    // .catch((error) => {
    //   toast.error(error.response.data.message);
    // });
    // }
  };

  onChangeUser = (e) => {
    let value = e.target.value;
    if (e.target.type == 'date') {
      value = moment(e.target.value).format('YYYY-MM-DD');
    }
    this.setState({
      userFields: {
        ...this.state.userFields,
        [e.target.name]: value
      }
    });
  };


  generatePassword = () => {
    let length = 12,
      charset = 'abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789 #?!@$%^&*-',
      charsetArr = charset.split(' ');
    let retVal = '';
    charsetArr.forEach(chars => {
      for (let i = 0, n = chars.length; i < length / charsetArr.length; ++i) {
        retVal += chars.charAt(Math.floor(Math.random() * n));
        retVal = [...retVal].sort(() => Math.random() - 0.5).join('');
      }
    });
    this.setState({ passwordVal: retVal });
    return retVal;
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      filterValue: {
        ...(this.state.filterValue || {}),
        [name]: value
      }
    }, () => {
      if (!value || value.trim() === '') {
        this.filterData();
      }
    });
  };

  render() {
    return (
      <ManageUser
        stations={this.props.stations}
        filteredData={this.state.filteredData}
        filter={this.state.filter}
        modal={this.state.modal}
        action={this.state.action}
        airlineList={this.state.airlineList}
        otherUserList={this.state.otherUserList}
        tryUserFields={this.state.tryUserFields}
        onChangeTry={this.onChangeTry}
        onSearchTry={this.fetchOtherUsers}
        userFields={this.state.userFields}
        userErrors={this.state.userErrors}
        anchorEl={this.state.anchorEl}
        location={this.state.location}
        locationType={this.state.locationType}
        training={this.state.training}
        doc={this.state.doc}
        onChangeFilter={this.onChangeFilter}
        handleDoc={this.handleDoc}
        handleLocation={this.handleLocation}
        station={this.state.station}
        handleOpen={this.handleOpen}
        onClose={this.onClose}
        addUser={this.addUser}
        editUser={this.editUser}
        onChange={this.onChange}
        handleChangePassword={this.handleChangePassword}
        active={this.active}
        deactive={this.deactive}
        handleTraining={this.handleTraining}
        generatePassword={this.generatePassword}
        passwordVal={this.state.passwordVal}
        successModal={this.state.successModal}
        handleRetraining={this.handleRetraining}
        onChangeUser={this.onChangeUser}
        handleFilterChange={this.handleFilterChange}
        filterValue={this.state.filterValue}
        filterData={this.filterData}
        handleExport={this.handleExport}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    doc: state.doc,
    stations: state.stations
  };
};

const mapDispatchToProps = (dispatch) => {
  return { setDoc: (data) => dispatch(setDocAction(data)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserContainer);
